// Actions
import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/**
 * The list of ActionType constants that DependencyStore registers for.
 */ export const DependencyStoreActionTypes = [
    ActionType.FetchEntityCollectionAction,
    ActionType.FetchEntityCollectionFailedAction,
    ActionType.FetchEntityCollectionSucceededAction,
    ActionType.CreateEntityAction,
    ActionType.CreateEntityFailedAction,
    ActionType.CreateEntitySucceededAction,
    ActionType.UpdateEntityAction,
    ActionType.UpdateEntityFailedAction,
    ActionType.UpdateEntitySucceededAction,
    ActionType.DeleteEntityAction,
    ActionType.DeleteEntityFailedAction,
    ActionType.DeleteEntitySucceededAction,
    ActionType.DeltaSyncAction,
    ActionType.DeltaSyncSucceededAction,
    ActionType.DeltaSyncFailedAction
];
